const objectFit = {
    name: "object-fit",
    path: "/object-fit",
    title: "object-fit",
    description: "Utilities for controlling whether an element should explicitly create a new stacking context.",
    value: {
       "object-fit": {
         "object-contain": "contain",
        "object-cover": "cover",
        "object-fill": "fill",
        "object-none": "none",
        "object-scale-down": "scale-down",
       }
    },
    exampleData: [
        {
            "title": "object-cover",
            "description": "utility to resize an element's content to cover its container:",
            "moreDescription": "",
            "parentClass": "max-w-96",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "mx-auto h-48 w-96 rounded-lg object-cover"
                    }
                ],
                "className": "",
                "code": '<img class="h-48 w-96 object-cover ..." src="/img/mountains.jpg" />'
            }
        },
        {
            "title": "object-contain",
            "description": "utility to resize an element's content to stay contained within its container:",
            "moreDescription": "",
            "parentClass": "max-w-96",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "mx-auto h-48 w-96 object-contain rounded-lg"
                    }
                ],
                "className": "",
                "code": '<img class="h-48 w-96 object-contain ..." src="/img/mountains.jpg" />'
            }
        },
        {
            "title": "object-fill",
            "description": "utility to stretch an element's content to fit its container:",
            "moreDescription": "",
            "parentClass": "max-w-96",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "mx-auto h-48 w-96 object-fill rounded-lg"
                    }
                ],
                "className": "",
                "code": '<img class="h-48 w-96 object-fill ..." src="/img/mountains.jpg" />'
            }
        },
        {
            "title": "object-scale-down",
            "description": "utility to display an element's content at its original size but scale it down to fit its container if necessary:",
            "moreDescription": "",
            "parentClass": "max-w-96",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "mx-auto h-48 w-96 object-scale-down rounded-lg"
                    }
                ],
                "className": "",
                "code": '<img class="h-48 w-96 object-scale-down ..." src="/img/mountains.jpg" />'
            }
        },
        {
            "title": "object-none",
            "description": "utility to display an element's content at its original size ignoring the container size:",
            "moreDescription": "",
            "parentClass": "max-w-96",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "mx-auto h-48 w-96 object-none rounded-lg"
                    }
                ],
                "className": "",
                "code": '<img class="h-48 w-96 object-none ..." src="/img/mountains.jpg" />'
            }
        },
    ],
};

export default objectFit;